<template>
    <div id="InputHora">
        <input id="horario"
               type="text"
               class="timepicker"
               ref="horaTarefa"
               :value="value.horaTarefa"
               @change="updateHour()">
        <label>{{ label }}</label>
    </div>
</template>

<script>
    export default {
        data: () => ({
            label: "Horário",
        }),
        props: ['value'],
        methods: {
            updateHour() {
                this.$emit('input', {
                    data: +this.$refs.horaTarefa.value,
                })
            }
        },
        mounted() {
            $(this.$refs.horaTarefa).pickatime({
                default: 'now', // Set default time: 'now', '1:30AM', '16:30'
                fromnow: 0,       // set default time to * milliseconds from now (using with default = 'now')
                twelvehour: false, // Use AM/PM or 24-hour format
                donetext: 'OK', // text for done-button
                cleartext: 'Limpar', // text for clear-button
                canceltext: 'Cancelar', // Text for cancel-button,
                container: 'body', // ex. 'body' will append picker to body
                autoclose: false, // automatic close timepicker
                ampmclickable: true, // make AM PM clickable
                aftershow: function(){} //Function for after opening timepicker
            });
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/lead/form/InputHora.vue